import { render, staticRenderFns } from "./baseAppComponent.vue?vue&type=template&id=477f770a&"
import script from "./baseAppComponent.vue?vue&type=script&lang=js&"
export * from "./baseAppComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports